import lottie from 'lottie-web';
import { useEffect, useRef } from 'react';
import '../ResellerReport/ResellerTableInitial.scss';
import animationData from '../../../Assets/images/json/dar_reseller_report_load.json';

const PoMisTableInitial = () => {
  const animationContainer = useRef(null);

  useEffect(() => {
    lottie.loadAnimation({
      container: animationContainer.current,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData,
    });
  }, []);

  return (
    <div className="reseller-report-initial-loader-outer-layer">
      <div ref={animationContainer} className="reseller-table-initial-loader">
        <div style={{ textAlign: 'center', marginTop: 16 }}>
          Please select filters to view the report.
        </div>
      </div>
    </div>
  );
};

export default PoMisTableInitial;
